import React from 'react';
export function PricingSection() {
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-228">
      <div id="precio" className="mt-4 bg-[var(--card)] border-2 border-[var(--red2)]/40 rounded-2xl p-8 px-10 text-center" data-id="element-229">
        <span className="inline-block bg-[var(--red)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-3 uppercase" data-id="element-230">
          OFERTA DE LANZAMIENTO
        </span>

        <h2 className="text-[22px] font-bold mb-2" data-id="element-231">
          Una sola decisión equivocada
        </h2>
        <p className="text-white text-[15px] mb-5" data-id="element-232">
          puede costarte meses de tu vida y tiempo que no vuelve.
        </p>

        <div className="text-[13px] text-[var(--muted)] tracking-wider mb-1" data-id="element-233">
          VALOR TOTAL
        </div>
        <div className="text-[26px] font-black text-[#666] line-through mb-0.5" data-id="element-234">
          $97 USD
        </div>

        <div className="text-[13px] text-[var(--muted)] tracking-wider mb-1.5" data-id="element-235">
          TÚ PAGAS HOY
        </div>
        <div className="text-[64px] font-black text-white leading-none" data-id="element-236">
          $17
        </div>
        <div className="text-[13px] text-[var(--muted)] mt-1.5 mb-5" data-id="element-237">
          USD · Pago único · Acceso inmediato
        </div>

        <a href="https://www.auditoriacodigorojo.decidirconclaridad.com/checkouts/cn/hWNBZNo3vNtVEtV4LiscjXus/es-us" target="_blank" rel="noopener noreferrer" className="block bg-[var(--red2)] text-white text-center py-4 px-6 rounded-xl font-bold text-[15px] tracking-wider hover:bg-[#a82040] transition-colors" data-id="element-238">
          OBTENER MI ACCESO INSTANTÁNEO POR $17 →
        </a>

        <p className="text-[var(--muted)] text-xs mt-2.5" data-id="element-239">
          Acceso inmediato · Descarga segura · Tu privacidad es nuestra
          prioridad
        </p>
      </div>
    </section>;
}